import React from 'react';

const Riddle = ({ riddle, isActiveWomensMode }) => {
    if (!riddle) return null;

    const bgImage = isActiveWomensMode
        ? '/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg'
        : '/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg';

    const instruction = riddle.instruction || 'ADIVINA ADIVINADOR';
    const isRevealed = Boolean(riddle.isItemVisible);
    const silhouetteImage = riddle.image;
    const revealedImage = riddle.response?.image || riddle.image;
    const solutionText = riddle.response?.text || '';
    const options = Array.isArray(riddle.options) ? riddle.options : [];

    return (
        <>
            {/* Encabezado / Fondo */}
            <div className='Screen__Riddle__Background'>
                <img
                    src={bgImage}
                    alt="Fondo Pantalla"
                    className='Riddle__Screen__Background__Image'
                />
            </div>

            {/* Contenido */}
            <section className='Riddle__Screen__Box'>
                <p className='Riddle__Screen__Box__Title' style={{ textTransform: 'uppercase' }}>
                    {instruction}
                </p>

                {isRevealed ? (
                    <div className='Riddle__Screen__Box__Container--Visible'>
                        {revealedImage && (
                            <img
                                src={revealedImage}
                                alt="Respuesta Revelada"
                                className='Riddle__Screen__Box__Container--Visible__Image'
                            />
                        )}

                        <div className='Riddle__Screen__Box__Container--Visible__Response'>
                            <p
                                className='Riddle__Screen__Box__Container--Visible__Response__Text'
                                style={{ textTransform: 'uppercase' }}
                            >
                                {solutionText}
                            </p>
                            <img
                                src='/img/games/riddle/flecha-blanca.png'
                                alt="Flecha"
                                className='Riddle__Screen__Box__Container--Visible__Response__Image'
                            />
                        </div>
                    </div>
                ) : (
                    <div className='Riddle__Screen__Box__Container--Hidden'>
                        {silhouetteImage && (
                            <img
                                src={silhouetteImage}
                                alt="Silueta"
                                className='Riddle__Screen__Box__Container--Hidden__Image'
                            />
                        )}

                        <ul className='Riddle__Screen__Box__Container--Hidden__List'>
                            {options.map((option, index) => {
                                const text = typeof option === 'string' ? option : (option.text || option.name || '');
                                return (
                                    <li
                                        key={option.id ?? index}
                                        className='Riddle__Screen__Box__Container--Hidden__List__Item'
                                        style={{ textTransform: 'uppercase' }}
                                    >
                                        {text}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </section>

            <aside className="Riddle__Screen__Brand">
                <img
                    src="/img/games/riddle/female/january-24-2026/provi-logotipo.png"
                    alt="Brand Logo"
                    className="Riddle__Screen__Brand__Logo"
                />
            </aside>

            {/* Pie de página */}
            <footer className='Riddle__Screen__Footer'>
                <p className="text-center FooterCredits">Hecho con ♥ por Interaktia | 2026</p>
            </footer>
        </>
    );
};

export { Riddle };